import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { ROUTES } from '@/routes';

import EN_TO_KO_MARKET_NAME_MAP from '@/contents/englishToKoreanMarketNames';

// 고정 경로 매핑
const STATIC_PATH_TITLE_MAP: Record<string, string> = {
  [ROUTES.root]: '셀러박스',
  [ROUTES.signin]: '셀러박스',
  [ROUTES.legacySignin]: '셀러박스',
  [ROUTES.inquiry]: '1:1문의하기',
  [ROUTES.inquiryHistory]: '문의 내역 보기',
  [ROUTES.myProfile]: '프로필 수정',
  [ROUTES.reqAddMarket]: '마켓 추가 요청',
  [ROUTES.market]: '마켓 연동',
  [ROUTES.productShipment]: '상품 발송',
  [ROUTES.moreMembership]: '멤버십',
};

// 주문내역 orderTab 매핑
const ORDER_TAB_TITLE_MAP: Record<string, string> = {
  'new-order': '신규 주문',
  'ready-to-ship': '발송대기',
  shipping: '배송중',
  delivered: '배송완료',
  cancel: '취소',
  exchange: '교환',
  return: '반품',
};

// 추가 경로 매핑
const ADDITIONAL_PATH_TITLE_MAP: Record<string, string> = {
  [ROUTES.reviews]: '리뷰관리',
  [ROUTES.inquiries]: '문의 관리',
  [ROUTES.statistics]: '통계',
  [ROUTES.monitoring]: '상품순위 모니터링',
};

// /more ctab 매핑
const MORE_CTAB_TITLE_MAP: Record<string, string> = {
  membership: '멤버십 이용내역',
  faq: 'FAQ',
  support: '1:1 문의',
};

// 정규식 경로 매핑
type RegexTitleHandler = (match: RegExpMatchArray) => string;

const REGEX_TITLE_MAP: Array<{
  regex: RegExp;
  handler: RegexTitleHandler;
}> = [
  {
    regex: new RegExp(`^${ROUTES.marketRegister}/([^/]+)$`, 'i'),
    handler: (match) => {
      const marketName = EN_TO_KO_MARKET_NAME_MAP[match[1]] || '';
      return `${marketName} 연동`;
    },
  },
  {
    regex: new RegExp(`^${ROUTES.changePassword}/([^/]+)$`, 'i'),
    handler: () => '비밀번호 수정',
  },
];

const getTitleForPath = (path: string, searchParams: URLSearchParams): string => {
  // 주문내역 케이스
  if (path.startsWith(ROUTES.orderDetails)) {
    const orderTab = searchParams.get('orderTab');
    if (orderTab && ORDER_TAB_TITLE_MAP[orderTab]) {
      return `주문내역 | ${ORDER_TAB_TITLE_MAP[orderTab]}`;
    }
  }

  // /more 케이스
  if (path === ROUTES.more) {
    const ctab = searchParams.get('ctab');
    if (ctab && MORE_CTAB_TITLE_MAP[ctab]) {
      return `더보기 | ${MORE_CTAB_TITLE_MAP[ctab]}`;
    }
  }

  // 추가 경로 매핑
  if (ADDITIONAL_PATH_TITLE_MAP[path]) {
    return ADDITIONAL_PATH_TITLE_MAP[path];
  }

  // 고정 매핑
  if (STATIC_PATH_TITLE_MAP[path]) {
    return STATIC_PATH_TITLE_MAP[path];
  }

  // 정규식 매핑
  for (const { regex, handler } of REGEX_TITLE_MAP) {
    const match = path.match(regex);
    if (match) {
      return handler(match);
    }
  }

  // 기본값
  return '셀러박스';
};

function DocumentTitleUpdater() {
  const location = useLocation();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const pageTitle = getTitleForPath(location.pathname, searchParams);
    document.title = pageTitle;
  }, [location]);

  return null;
}

export default DocumentTitleUpdater;
